import axios, { microServices } from './axios'
import { loaders } from './../constants'

const ACCOUNT_EXPORT = '/account-export'
const DOWNLOAD_EXPORT = '/account-export/download'

export const exportUserAccountData = async (data) => {
    return await axios('post', `${ACCOUNT_EXPORT}/`, data, { loader: loaders.OVERLAY, server: microServices.DE }).then(data => {
        return data
    }).catch(error => {
        console.error('Export request failed:', error);
        throw error;
    });
}

export const checkUserAccountExportStatus = async (data) => {
    return await axios('get', `${ACCOUNT_EXPORT}/status/${data.account_id}`,{}, { server: microServices.DE }).then(data => {
        return data
    }).catch(error => {
        console.error('Export status check failed:', error);
        throw error;
    });
}

export const downloadUserAccountExport = async (data) => {
    try {
        const response = await axios('get', `${DOWNLOAD_EXPORT}/${data.account_id}`, {}, {
            loader: loaders.OVERLAY,
            server: microServices.DE
        });
        
        if (response && response.status === 'SUCCESS') {
            const { url, filename } = response;
            if (url) {
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename || `account_export_${data.account_id}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
        return response;
    } catch (error) {
        console.error('Export download failed:', error);
        throw error;
    }
}